<template>
  <div
    :class="{
      [paddingForStickyAddToCart]: isOnProductPage
    }"
  >
    <NoFooterLayout
      :full-width="fullWidth"
      :categories-container="categoriesContainer?.container"
      :product="productContainer?.product"
    >
      <slot />
    </NoFooterLayout>
    <SectionTransition
      :has-content="showNewsletter"
      client-only
    >
      <NewsletterWrapper @newsletter-consent="newsletterConsentCheck" />
    </SectionTransition>
    <AppFooterWrapper :categories-container="categoriesContainer?.container" />
  </div>
</template>

<script lang="ts">
import NoFooterLayout from './no-footer-layout.vue';
import { useUser } from '~/utils/ct';
import { getProductSku } from '~~/helpers/routes/getPageInformation';

export default defineComponent({
  name: 'Default',
  components: {
    NoFooterLayout,
  },
  props: {
    fullWidth: Boolean,
  },
  async setup() {

    const route = useRoute();
    const sku = computed(() => getProductSku(slug.value));

    const { isAuthenticated } = useUser();
    const hasNewsletterConsent = ref(false);
    const { isOnProductPage, isOnNewsletterConfirmationPage } = useIsPage();
    const showNewsletter = computed(() => {
      
      return !isAuthenticated.value && !hasNewsletterConsent.value && !isOnNewsletterConfirmationPage.value;
    
    });
    const { languageAndCountry } = useLocalization();

    const { load: loadStore, isLoaded: isStoreLoaded } = useStoreVsfExtended();
    const storeFetch = useLazyAsyncData('load-store-default', async () => {

      if (!isStoreLoaded.value) {

        await loadStore();

      }

      return true;

    });
    const paddingForStickyAddToCart = 'pb-22 lg:pb-18';
    const slug = computed(() => Array.isArray(route?.params?.slug)
      ? route.params.slug[0]
      : route?.params?.slug || '');
      
    const {
      search: searchProduct,
      masterProduct,
    } = useProductExtended(slug.value);

    const {
      loadFirstLevelCategories,
      firstLevelCategoriesContainer,
    } = useCategoryExtended();

    const categoriesFetch = useLazyAsyncData(`categories-navigation`, async () => {

      try {

        await loadFirstLevelCategories(languageAndCountry.value);
      
      } catch (e) {

        console.error('error during loadFirstLevelCategories', e);
      
      }

      return {
        container: firstLevelCategoriesContainer.value || null,
      };
    
    });
    const productFetch = useLazyAsyncData(
      () => `product-${slug.value}`,
      async () => {

        try {

          if (isOnProductPage.value) {

            await searchProduct({ skus: [sku.value] });

            return { product: masterProduct.value || null };
          
          }

          return { product: null };
        
        } catch (e) {

          console.error('error during product fetch', e);

          return { product: null };
        
        }
      
      },
    );
    const [, categoriesFetchResult, productFetchResult] = await Promise.all([storeFetch, categoriesFetch, productFetch]);

    const categoriesContainer = computed(() => categoriesFetchResult?.data?.value || null);
    const productContainer = computed(() => productFetchResult?.data?.value || null);

    const newsletterConsentCheck = (consent?: boolean) => {

      hasNewsletterConsent.value = Boolean(consent);

    };
    
    return {
      showNewsletter,
      isOnProductPage,
      paddingForStickyAddToCart,
      categoriesContainer,
      productContainer,
      productFetchResult,
      newsletterConsentCheck,
    };
  
  },
});
</script>
